module.exports = __webpack_public_path__ + "img/right-link-banner-en.b069dfaf.png";